// import logo from "./logo.svg";
import "./App.scss";
import { useEffect, useState, useRef } from "react";
import Poscard from "./components/Poscard";
import Frog from "./components/Frog";
import SpotDifference from "./components/SpotDifference";
import otterVideo from "./resources/otter1.mp4";
import otterVideo2 from "./resources/otter2.mp4";
import otterVideo3 from "./resources/otter3.mp4";
import otterVideo4 from "./resources/otter4.mp4";
import otterVideo5 from "./resources/otterWasps.mp4";
import otterVideo6 from "./resources/otter5.mp4";
import otterVideo7 from "./resources/otter6.mp4";
import otterVideo8 from "./resources/otter7.mp4";
import otterVideoHappy from "./resources/otterHappy.mp4";
import forestVideo from "./resources/videos/forestVideo.mp4";

// Longest flower delay (--d:4.8s) plus the 2s grow-ans duration.
const FLOWERS_BLOOM_MS = 6800;

function App() {
  const [showFlowers, setShowFlowers] = useState(false);
  const [showBoxes, setShowBoxes] = useState(0);
  const [frogHops, setFrogHops] = useState(false);
  const [frogStage, setFrogStage] = useState(null); // null | "forest" | "game"
  const stars = [
    { top: 100, left: 100, move: 1 },
    { top: 200, left: 200, move: 2 },
    { top: 300, left: 300, move: 1 },
    { top: 400, left: 400, move: 2 },
    { top: 100, left: 400, move: 2 },
    { top: 200, left: 300, move: 1 },
    { top: 300, left: 200, move: 1 },
    { top: 400, left: 100, move: 2 },
    { top: 100, left: 900, move: 2 },
    { top: 200, left: 800, move: 2 },
    { top: 300, left: 1200, move: 1 },
    { top: 400, left: 600, move: 1 },
    { top: 500, left: 800, move: 1 },
    { top: 400, left: 1200, move: 2 },
    { top: 300, left: 1400, move: 1 },
    { top: 200, left: 600, move: 2 },
    { top: 100, left: 200, move: 1 },
    { top: 100, left: 1400, move: 2 },
    { top: 300, left: 1500, move: 1 },
    { top: 400, left: 1700, move: 2 },
    { top: 50, left: 1800, move: 1 },
  ];
  const talkOtter = [
    "Hola, Valeria! Soc l’esperit del Summer. Moltes felicitats pels teus 23 anys! ❤️",
    "Necessito la teva ajuda, perquè el Summer està en perill!",
    "Resulta que un dia el seu pare el va deixar jugar una estona al jardí.",
    "De cop i volta va aparèixer una vespa dolenta, i el Summer es va defensar.",
    "Però la vespa va tornar amb un grup de deu més, i el van perseguir.",
    "El Summer, desesperat, va sortir corrents a amagar-se al primer lloc que va trobar.",
    "Era un forat molt fosc, i allà va esperar uns minuts fins que les vespes marxessin.",
    "Però quan ja no les veia, va sentir un soroll al fons del forat.",
    "Va tocar amb la mà allò que compartia el forat amb ell, i en un instant va sortir!",
    "Era un ratolí de camp, inofensiu. Però de l’ensurt, el Summer va sortir corrents cap a fora.",
    "Va córrer fins a una habitació del jardí oberta, on hi havia tubs i cables, i s’hi va amagar.",
    "Però aquella habitació ja havia estat conquerida per un grup de dragons escorredissos,",
    "que de seguida van intentar fer-lo fora. Finalment, el Summer se’n va anar corre-cuita cap al bosc.",
    "Ara no sabem on és, però la meva intuïció em diu que s’ha amagat dins d’una caixa",
    "que hi havia per allà. Si us plau, Valeria, troba’l, que segur que serà un gran tresor!",
    "Per poder trobar la caixa has de pensar on s'amagaria el summer",
    "pensa com si fos un goseet!",
  ];
  const [talkCount, setTalkCount] = useState(0);
  const videoRef = useRef(null);
  const forestRef = useRef(null);

  useEffect(() => {
    toggleStarlight();
  }, []);

  useEffect(() => {
    if (frogStage !== "forest") return;
    const video = forestRef.current;
    if (!video) return;
    const attempt = video.play();
    if (attempt) {
      attempt.catch(() => {
        video.muted = true;
        video.play().catch(() => setFrogStage("game"));
      });
    }
  }, [frogStage]);

  useEffect(() => {
    if (!showFlowers) return;
    const timer = setTimeout(() => setFrogHops(true), FLOWERS_BLOOM_MS);
    return () => clearTimeout(timer);
  }, [showFlowers]);

  const getVideo = () => {
    if (talkCount === 2) return otterVideo;
    else if (talkCount === 3) return otterVideo2;
    else if (talkCount === 4) return otterVideo5;
    else if (talkCount === 5) return otterVideo3;
    else if (talkCount === 9) return otterVideo4;
    else if (talkCount === 10) return otterVideo6;
    else if (talkCount === 12) return otterVideo7;
    else if (talkCount === 13) return otterVideo8;
    return null;
  };

  const startFlowers = () => {
    setShowFlowers(true);
  };

  const toggleStarlight = () => {
    const elements = document.getElementsByClassName("starlight");

    // Hide for 2 seconds
    for (let el of elements) {
      el.style.display = "none";
    }

    setTimeout(() => {
      // Show for 5 seconds
      for (let el of elements) {
        el.style.display = "block";
      }

      // Repeat the cycle after 5 seconds
      setTimeout(toggleStarlight, 5000);
    }, 7000);
  };

  const flowerClick = (flower) => {
    setShowBoxes((oldValue) => oldValue + 1);
    const leaves = document.querySelectorAll(
      `.flower--${flower} .flower__leaf`
    );
    const animationMap = {
      1: "moving-flower-click-1",
      2: "moving-flower-click-2",
      3: "moving-flower-click-3",
      5: "moving-flower-click-5",
      6: "moving-flower-click-6",
      8: "moving-flower-click-8",
    };
    leaves.forEach((leaf, index) => {
      const animationClass = animationMap[index + 1];
      if (animationClass) {
        leaf.style.animation = `${animationClass} 3s infinite`;
      }
    });
  };

  if (frogStage === "forest") {
    return (
      <div className="App">
        <video
          ref={forestRef}
          className="forest-video"
          src={forestVideo}
          autoPlay
          playsInline
          onEnded={() => setFrogStage("game")}
          onContextMenu={(e) => e.preventDefault()}
        ></video>
      </div>
    );
  }

  if (frogStage === "game") {
    return (
      <div className="App">
        <SpotDifference onFinish={() => setFrogStage(null)}></SpotDifference>
      </div>
    );
  }

  return (
    <div className="App">
      {showBoxes >= 7 && (
        <div>
          <video
            ref={videoRef}
            id="videoOtterhappy"
            className="video-otter-happy"
            width="800"
            autoPlay
            muted
            loop
            src={otterVideoHappy}
          ></video>
          <button className="restart-button" onClick={() => setShowBoxes(0)}>
            Torna a començar
          </button>
        </div>
      )}
      {showBoxes < 7 && (
        <div className="scene">
          <div id="night" className="night">
            {!showFlowers && <Poscard startFlowers={startFlowers}></Poscard>}
          </div>
          {stars.map((star, i) => (
            <div
              key={i}
              className={`star star-move-${star.move}`}
              style={{ top: `${star.top}px`, left: `${star.left}px` }}
            />
          ))}

          <div
            className="starlight starlight-move"
            style={{ top: "500px", left: "100px" }}
          />

          {showFlowers && (
            <div className="flowers">
              <div className="flower flower--1">
                <div className="flower__leafs flower__leafs--1">
                  <div className="flower__leaf flower__leaf--5"></div>
                  <div className="flower__leaf flower__leaf--6"></div>
                  <div className="flower__leaf flower__leaf--1"></div>
                  <div className="flower__leaf flower__leaf--2"></div>
                  <div className="flower__leaf flower__leaf--3"></div>
                  <div className="flower__leaf flower__leaf--8"></div>
                  <div
                    className="flower__leaf flower__leaf--4"
                    onClick={() => flowerClick(1)}
                  ></div>
                  <div className="flower__leaf flower__leaf--7"></div>
                  <div className="flower__white-circle"></div>

                  <div className="flower__light flower__light--1"></div>
                  <div className="flower__light flower__light--2"></div>
                  <div className="flower__light flower__light--3"></div>
                  <div className="flower__light flower__light--4"></div>
                  <div className="flower__light flower__light--5"></div>
                  <div className="flower__light flower__light--6"></div>
                  <div className="flower__light flower__light--7"></div>
                  <div className="flower__light flower__light--8"></div>
                </div>
                <div className="flower__line">
                  <div className="flower__line__leaf flower__line__leaf--1"></div>
                  <div className="flower__line__leaf flower__line__leaf--2"></div>
                  <div className="flower__line__leaf flower__line__leaf--3"></div>
                  <div className="flower__line__leaf flower__line__leaf--4"></div>
                  <div className="flower__line__leaf flower__line__leaf--5"></div>
                  <div className="flower__line__leaf flower__line__leaf--6"></div>
                </div>
              </div>

              <div className="flower flower--2">
                <div className="flower__leafs flower__leafs--2">
                  <div className="flower__leaf flower__leaf--5"></div>
                  <div className="flower__leaf flower__leaf--6"></div>
                  <div className="flower__leaf flower__leaf--1"></div>
                  <div className="flower__leaf flower__leaf--2"></div>
                  <div className="flower__leaf flower__leaf--3"></div>
                  <div className="flower__leaf flower__leaf--8"></div>
                  <div
                    className="flower__leaf flower__leaf--4"
                    onClick={() => flowerClick(2)}
                  ></div>
                  <div className="flower__leaf flower__leaf--7"></div>
                  <div className="flower__white-circle"></div>

                  <div className="flower__light flower__light--1"></div>
                  <div className="flower__light flower__light--2"></div>
                  <div className="flower__light flower__light--3"></div>
                  <div className="flower__light flower__light--4"></div>
                  <div className="flower__light flower__light--5"></div>
                  <div className="flower__light flower__light--6"></div>
                  <div className="flower__light flower__light--7"></div>
                  <div className="flower__light flower__light--8"></div>
                </div>
                <div className="flower__line">
                  <div className="flower__line__leaf flower__line__leaf--1"></div>
                  <div className="flower__line__leaf flower__line__leaf--2"></div>
                  <div className="flower__line__leaf flower__line__leaf--3"></div>
                  <div className="flower__line__leaf flower__line__leaf--4"></div>
                </div>
              </div>

              <div className="flower flower--3">
                <div className="flower__leafs flower__leafs--3">
                  <div className="flower__leaf flower__leaf--5"></div>
                  <div className="flower__leaf flower__leaf--6"></div>
                  <div className="flower__leaf flower__leaf--1"></div>
                  <div className="flower__leaf flower__leaf--2"></div>
                  <div className="flower__leaf flower__leaf--3"></div>
                  <div className="flower__leaf flower__leaf--8"></div>
                  <div
                    className="flower__leaf flower__leaf--4"
                    onClick={() => flowerClick(3)}
                  ></div>
                  <div className="flower__leaf flower__leaf--7"></div>
                  <div className="flower__white-circle"></div>

                  <div className="flower__light flower__light--1"></div>
                  <div className="flower__light flower__light--2"></div>
                  <div className="flower__light flower__light--3"></div>
                  <div className="flower__light flower__light--4"></div>
                  <div className="flower__light flower__light--5"></div>
                  <div className="flower__light flower__light--6"></div>
                  <div className="flower__light flower__light--7"></div>
                  <div className="flower__light flower__light--8"></div>
                </div>
                <div className="flower__line">
                  <div className="flower__line__leaf flower__line__leaf--1"></div>
                  <div className="flower__line__leaf flower__line__leaf--2"></div>
                  <div className="flower__line__leaf flower__line__leaf--3"></div>
                  <div className="flower__line__leaf flower__line__leaf--4"></div>
                </div>
              </div>

              <div className="flower flower--5">
                <div className="flower__leafs flower__leafs--1">
                  <div className="flower__leaf flower__leaf--5"></div>
                  <div className="flower__leaf flower__leaf--6"></div>
                  <div className="flower__leaf flower__leaf--1"></div>
                  <div className="flower__leaf flower__leaf--2"></div>
                  <div className="flower__leaf flower__leaf--3"></div>
                  <div className="flower__leaf flower__leaf--8"></div>
                  <div
                    className="flower__leaf flower__leaf--4"
                    onClick={() => flowerClick(5)}
                  ></div>
                  <div className="flower__leaf flower__leaf--7"></div>
                  <div className="flower__white-circle"></div>

                  <div className="flower__light flower__light--1"></div>
                  <div className="flower__light flower__light--2"></div>
                  <div className="flower__light flower__light--3"></div>
                  <div className="flower__light flower__light--4"></div>
                  <div className="flower__light flower__light--5"></div>
                  <div className="flower__light flower__light--6"></div>
                  <div className="flower__light flower__light--7"></div>
                  <div className="flower__light flower__light--8"></div>
                </div>
                <div className="flower__line">
                  <div className="flower__line__leaf flower__line__leaf--1"></div>
                  <div className="flower__line__leaf flower__line__leaf--2"></div>
                  <div className="flower__line__leaf flower__line__leaf--3"></div>
                  <div className="flower__line__leaf flower__line__leaf--4"></div>
                  <div className="flower__line__leaf flower__line__leaf--5"></div>
                  <div className="flower__line__leaf flower__line__leaf--6"></div>
                </div>
              </div>

              <div className="flower flower--6">
                <div className="flower__leafs flower__leafs--1">
                  <div className="flower__leaf flower__leaf--5"></div>
                  <div className="flower__leaf flower__leaf--6"></div>
                  <div className="flower__leaf flower__leaf--1"></div>
                  <div className="flower__leaf flower__leaf--2"></div>
                  <div className="flower__leaf flower__leaf--3"></div>
                  <div className="flower__leaf flower__leaf--8"></div>
                  <div
                    className="flower__leaf flower__leaf--4"
                    onClick={() => flowerClick(6)}
                  ></div>
                  <div className="flower__leaf flower__leaf--7"></div>
                  <div className="flower__white-circle"></div>

                  <div className="flower__light flower__light--1"></div>
                  <div className="flower__light flower__light--2"></div>
                  <div className="flower__light flower__light--3"></div>
                  <div className="flower__light flower__light--4"></div>
                  <div className="flower__light flower__light--5"></div>
                  <div className="flower__light flower__light--6"></div>
                  <div className="flower__light flower__light--7"></div>
                  <div className="flower__light flower__light--8"></div>
                </div>
                <div className="flower__line">
                  <div className="flower__line__leaf flower__line__leaf--1"></div>
                  <div className="flower__line__leaf flower__line__leaf--2"></div>
                  <div className="flower__line__leaf flower__line__leaf--3"></div>
                  <div className="flower__line__leaf flower__line__leaf--4"></div>
                  <div className="flower__line__leaf flower__line__leaf--5"></div>
                  <div className="flower__line__leaf flower__line__leaf--6"></div>
                </div>
              </div>

              <div className="flower flower--7">
                <div className="flower__leafs flower__leafs--1">
                  <div className="flower__leaf flower__leaf--5"></div>
                  <div className="flower__leaf flower__leaf--6"></div>
                  <div className="flower__leaf flower__leaf--1"></div>
                  <div className="flower__leaf flower__leaf--2"></div>
                  <div className="flower__leaf flower__leaf--3"></div>
                  <div className="flower__leaf flower__leaf--8"></div>
                  <div
                    className="flower__leaf flower__leaf--4"
                    onClick={() => flowerClick(7)}
                  ></div>
                  <div className="flower__leaf flower__leaf--7"></div>
                  <div className="flower__white-circle"></div>

                  <div className="flower__light flower__light--1"></div>
                  <div className="flower__light flower__light--2"></div>
                  <div className="flower__light flower__light--3"></div>
                  <div className="flower__light flower__light--4"></div>
                  <div className="flower__light flower__light--5"></div>
                  <div className="flower__light flower__light--6"></div>
                  <div className="flower__light flower__light--7"></div>
                  <div className="flower__light flower__light--8"></div>
                </div>
                <div className="flower__line">
                  <div className="flower__line__leaf flower__line__leaf--1"></div>
                  <div className="flower__line__leaf flower__line__leaf--2"></div>
                  <div className="flower__line__leaf flower__line__leaf--3"></div>
                  <div className="flower__line__leaf flower__line__leaf--4"></div>
                  <div className="flower__line__leaf flower__line__leaf--5"></div>
                  <div className="flower__line__leaf flower__line__leaf--6"></div>
                </div>
              </div>

              <div className="flower flower--8">
                <div className="flower__leafs flower__leafs--1">
                  <div className="flower__leaf flower__leaf--5"></div>
                  <div className="flower__leaf flower__leaf--6"></div>
                  <div className="flower__leaf flower__leaf--1"></div>
                  <div className="flower__leaf flower__leaf--2"></div>
                  <div className="flower__leaf flower__leaf--3"></div>
                  <div className="flower__leaf flower__leaf--8"></div>
                  <div
                    className="flower__leaf flower__leaf--4"
                    onClick={() => flowerClick(8)}
                  ></div>
                  <div className="flower__leaf flower__leaf--7"></div>
                  <div className="flower__white-circle"></div>

                  <div className="flower__light flower__light--1"></div>
                  <div className="flower__light flower__light--2"></div>
                  <div className="flower__light flower__light--3"></div>
                  <div className="flower__light flower__light--4"></div>
                  <div className="flower__light flower__light--5"></div>
                  <div className="flower__light flower__light--6"></div>
                  <div className="flower__light flower__light--7"></div>
                  <div className="flower__light flower__light--8"></div>
                </div>
                <div className="flower__line">
                  <div className="flower__line__leaf flower__line__leaf--1"></div>
                  <div className="flower__line__leaf flower__line__leaf--2"></div>
                  <div className="flower__line__leaf flower__line__leaf--3"></div>
                  <div className="flower__line__leaf flower__line__leaf--4"></div>
                  <div className="flower__line__leaf flower__line__leaf--5"></div>
                  <div className="flower__line__leaf flower__line__leaf--6"></div>
                </div>
              </div>

              <div className="grow-ans --d:1.2s">
                <div className="flower__g-long">
                  <div className="flower__g-long__top"></div>
                  <div className="flower__g-long__bottom"></div>
                </div>
              </div>

              <div className="growing-grass">
                <div className="flower__grass flower__grass--1">
                  <div className="flower__grass--top"></div>
                  <div className="flower__grass--bottom"></div>
                  <div className="flower__grass__leaf flower__grass__leaf--1"></div>
                  <div className="flower__grass__leaf flower__grass__leaf--2"></div>
                  <div className="flower__grass__leaf flower__grass__leaf--3"></div>
                  <div className="flower__grass__leaf flower__grass__leaf--4"></div>
                  <div className="flower__grass__leaf flower__grass__leaf--5"></div>
                  <div className="flower__grass__leaf flower__grass__leaf--6"></div>
                  <div className="flower__grass__leaf flower__grass__leaf--7"></div>
                  <div className="flower__grass__leaf flower__grass__leaf--8"></div>
                  <div className="flower__grass__overlay"></div>
                </div>
              </div>

              <div className="growing-grass">
                <div className="flower__grass flower__grass--2">
                  <div className="flower__grass--top"></div>
                  <div className="flower__grass--bottom"></div>
                  <div className="flower__grass__leaf flower__grass__leaf--1"></div>
                  <div className="flower__grass__leaf flower__grass__leaf--2"></div>
                  <div className="flower__grass__leaf flower__grass__leaf--3"></div>
                  <div className="flower__grass__leaf flower__grass__leaf--4"></div>
                  <div className="flower__grass__leaf flower__grass__leaf--5"></div>
                  <div className="flower__grass__leaf flower__grass__leaf--6"></div>
                  <div className="flower__grass__leaf flower__grass__leaf--7"></div>
                  <div className="flower__grass__leaf flower__grass__leaf--8"></div>
                  <div className="flower__grass__overlay"></div>
                </div>
              </div>

              <div className="grow-ans --d:2.4s">
                <div className="flower__g-right flower__g-right--1">
                  <div className="leaf"></div>
                </div>
              </div>

              <div className="grow-ans --d:2.8s">
                <div className="flower__g-right flower__g-right--2">
                  <div className="leaf"></div>
                </div>
              </div>

              <div className="grow-ans --d:2.8s">
                <div className="flower__g-front">
                  <div className="flower__g-front__leaf-wrapper flower__g-front__leaf-wrapper--1">
                    <div className="flower__g-front__leaf"></div>
                  </div>
                  <div className="flower__g-front__leaf-wrapper flower__g-front__leaf-wrapper--2">
                    <div className="flower__g-front__leaf"></div>
                  </div>
                  <div className="flower__g-front__leaf-wrapper flower__g-front__leaf-wrapper--3">
                    <div className="flower__g-front__leaf"></div>
                  </div>
                  <div className="flower__g-front__leaf-wrapper flower__g-front__leaf-wrapper--4">
                    <div className="flower__g-front__leaf"></div>
                  </div>
                  <div className="flower__g-front__leaf-wrapper flower__g-front__leaf-wrapper--5">
                    <div className="flower__g-front__leaf"></div>
                  </div>
                  <div className="flower__g-front__leaf-wrapper flower__g-front__leaf-wrapper--6">
                    <div className="flower__g-front__leaf"></div>
                  </div>
                  <div className="flower__g-front__leaf-wrapper flower__g-front__leaf-wrapper--7">
                    <div className="flower__g-front__leaf"></div>
                  </div>
                  <div className="flower__g-front__leaf-wrapper flower__g-front__leaf-wrapper--8">
                    <div className="flower__g-front__leaf"></div>
                  </div>
                  <div className="flower__g-front__line"></div>
                </div>
              </div>

              <div className="grow-ans --d:3.2s">
                <div className="flower__g-fr">
                  <div className="leaf"></div>
                  <div className="flower__g-fr__leaf flower__g-fr__leaf--1"></div>
                  <div className="flower__g-fr__leaf flower__g-fr__leaf--2"></div>
                  <div className="flower__g-fr__leaf flower__g-fr__leaf--3"></div>
                  <div className="flower__g-fr__leaf flower__g-fr__leaf--4"></div>
                  <div className="flower__g-fr__leaf flower__g-fr__leaf--5"></div>
                  <div className="flower__g-fr__leaf flower__g-fr__leaf--6"></div>
                  <div className="flower__g-fr__leaf flower__g-fr__leaf--7"></div>
                  <div className="flower__g-fr__leaf flower__g-fr__leaf--8"></div>
                </div>
              </div>

              <div className="long-g long-g--0" style={{ display: "none" }}>
                <div className="grow-ans --d:3s">
                  <div className="leaf leaf--0"></div>
                </div>
                <div className="grow-ans --d:2.2s">
                  <div className="leaf leaf--1"></div>
                </div>
                <div className="grow-ans --d:3.4s">
                  <div className="leaf leaf--2"></div>
                </div>
                <div className="grow-ans --d:3.6s">
                  <div className="leaf leaf--3"></div>
                </div>
              </div>

              <div className="long-g long-g--1">
                <div className="grow-ans --d:3.6s">
                  <div className="leaf leaf--0"></div>
                </div>
                <div className="grow-ans --d:3.8s">
                  <div className="leaf leaf--1"></div>
                </div>
                <div className="grow-ans --d:4s">
                  <div className="leaf leaf--2"></div>
                </div>
                <div className="grow-ans --d:4.2s">
                  <div className="leaf leaf--3"></div>
                </div>
              </div>

              <div className="long-g long-g--2">
                <div className="grow-ans --d:4s">
                  <div className="leaf leaf--0"></div>
                </div>
                <div className="grow-ans --d:4.2s">
                  <div className="leaf leaf--1"></div>
                </div>
                <div className="grow-ans --d:4.4s">
                  <div className="leaf leaf--2"></div>
                </div>
                <div className="grow-ans --d:4.6s">
                  <div className="leaf leaf--3"></div>
                </div>
              </div>

              <div className="long-g long-g--3">
                <div className="grow-ans --d:4s">
                  <div className="leaf leaf--0"></div>
                </div>
                <div className="grow-ans --d:4.2s">
                  <div className="leaf leaf--1"></div>
                </div>
                <div className="grow-ans --d:3s">
                  <div className="leaf leaf--2"></div>
                </div>
                <div className="grow-ans --d:3.6s">
                  <div className="leaf leaf--3"></div>
                </div>
              </div>

              <div className="long-g long-g--4">
                <div className="grow-ans --d:4s">
                  <div className="leaf leaf--0"></div>
                </div>
                <div className="grow-ans --d:4.2s">
                  <div className="leaf leaf--1"></div>
                </div>
                <div className="grow-ans --d:3s">
                  <div className="leaf leaf--2"></div>
                </div>
                <div className="grow-ans --d:3.6s">
                  <div className="leaf leaf--3"></div>
                </div>
              </div>

              <div className="long-g long-g--5">
                <div className="grow-ans --d:4s">
                  <div className="leaf leaf--0"></div>
                </div>
                <div className="grow-ans --d:4.2s">
                  <div className="leaf leaf--1"></div>
                </div>
                <div className="grow-ans --d:3s">
                  <div className="leaf leaf--2"></div>
                </div>
                <div className="grow-ans --d:3.6s">
                  <div className="leaf leaf--3"></div>
                </div>
              </div>

              <div className="long-g long-g--6">
                <div className="grow-ans --d:4.2s">
                  <div className="leaf leaf--0"></div>
                </div>
                <div className="grow-ans --d:4.4s">
                  <div className="leaf leaf--1"></div>
                </div>
                <div className="grow-ans --d:4.6s">
                  <div className="leaf leaf--2"></div>
                </div>
                <div className="grow-ans --d:4.8s">
                  <div className="leaf leaf--3"></div>
                </div>
              </div>

              <div className="long-g long-g--7">
                <div className="grow-ans --d:3s">
                  <div className="leaf leaf--0"></div>
                </div>
                <div className="grow-ans --d:3.2s">
                  <div className="leaf leaf--1"></div>
                </div>
                <div className="grow-ans --d:3.5s">
                  <div className="leaf leaf--2"></div>
                </div>
                <div className="grow-ans --d:3.6s">
                  <div className="leaf leaf--3"></div>
                </div>
              </div>

              {frogHops && <Frog onClick={() => setFrogStage("forest")}></Frog>}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default App;
